<script setup lang="ts">
import { useAuth } from './composables/useAuth'

const auth = useAuth()
</script>

<template>
  <RouterView />
  <div id="after-content-teleport"></div>
  <span class="debug">
    Auth:
    {{
      `${auth.state.value}${auth.token.value ? ' | Token=' + auth.token.value : ''}`
    }}</span
  >
</template>

<style scoped>
.debug {
  font: 10px/1 monospace;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 8px;
  background: #4448;
  color: #fff;
}
</style>
